export default __webpack_public_path__ + "static/media/TF_16.95464003.png";